document.addEventListener('DOMContentLoaded', () => {
  const EBOOK_VARIANT_ID = "47156332691697";

  document.body.addEventListener('click', async (event) => {
    const addToCartButton = event.target.closest('button[name="add"]');
    if (!addToCartButton || addToCartButton.dataset.giftHandlerAttached) return;

    const form = addToCartButton.closest('form');
    if (!form) return;

    const sellingPlanInput = form.querySelector('[name="selling_plan"]');
    const sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;

    if (sellingPlanId && sellingPlanId !== '') {
      event.preventDefault();

      try {
        const cart = await (await fetch('/cart.js')).json();
        const ebookAlreadyInCart = cart.items.some(item => String(item.variant_id) === EBOOK_VARIANT_ID);

        if (!ebookAlreadyInCart) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: EBOOK_VARIANT_ID, quantity: 1, properties: { 'Note': 'Free Gift' } }] })
          });
        }
      } catch (error) {
        console.error('Gift Add Error:', error);
      } finally {
        addToCartButton.dataset.giftHandlerAttached = true;
        addToCartButton.click();
      }
    }
  }, true);

  const cartNode = document.querySelector('#CartDrawer, form.cart');
  let isCheckingCart = false;

  const handleCartChange = async () => {
    if (isCheckingCart) return;
    isCheckingCart = true;

    try {
      const cart = await theme.cart.getCart();
      const hasSubscription = cart.items.some(item => item.selling_plan_allocation);
      const ebookLine = cart.items.find(item => String(item.variant_id) === EBOOK_VARIANT_ID);

      if (!hasSubscription && ebookLine) {
        const updatedCart = await theme.cart.changeItem(ebookLine.key, 0);

        if (window.location.pathname.includes('/cart')) {          
          if (updatedCart.item_count === 0) {
            window.location.href = '/cart';
          } else {             
             document.querySelector(`.cart__row a[href*="${EBOOK_VARIANT_ID}"]`)?.closest('.cart__row').remove();             
             document.querySelector('.cart__row .h4:last-child').textContent = theme.Currency.formatMoney(updatedCart.total_price, theme.settings.moneyFormat);
          }
        } else {
          jQuery('body').trigger('added.ajaxProduct', updatedCart);
        }
      }
    } catch (error) {
      console.error('Gift Removal Error:', error);
    } finally {
      setTimeout(() => { isCheckingCart = false }, 1000);
    }
  };
  
  if (cartNode) {
    new MutationObserver(handleCartChange).observe(cartNode, { childList: true, subtree: true });
  }
});